var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"btns"},[_c('a-button',{staticStyle:{"margin-right":"20px"},attrs:{"type":"primary"},on:{"click":_vm.getStuInfo}},[_vm._v(" 刷新部门树状图 ")]),_c('a-button',{staticStyle:{"margin-right":"20px"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.addbm(0, '')}}},[_vm._v(" 新增 ")])],1),_c('div',{staticClass:"count"},[_c('a-tree',{attrs:{"load-data":_vm.onLoadData,"tree-data":_vm.data},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var treeKey = ref.key;
var title = ref.title;
var jgmc = ref.jgmc;
var jgh = ref.jgh;
var pid = ref.pid;
var dssjjgh = ref.dssjjgh;
var id = ref.id;
var item = ref.item;
return [_c('a-dropdown',{attrs:{"trigger":['contextmenu']},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('a-menu',[_c('a-menu-item',{on:{"click":function (ref) {
	var menuKey = ref.key;

	return _vm.scbm(id);
}}},[_vm._v("部门删除")]),_c('a-menu-item',{on:{"click":function (ref) {
	var menuKey = ref.key;

	return _vm.xgbm(id,pid);
}}},[_vm._v("部门修改")]),_c('a-menu-item',{on:{"click":function (ref) {
	var menuKey = ref.key;

	return _vm.addbm(pid, dssjjgh);
}}},[_vm._v("新增同级部门")]),_c('a-menu-item',{on:{"click":function (ref) {
	var menuKey = ref.key;

	return _vm.addbm(id, jgh);
}}},[_vm._v("新增下级部门")])],1)]},proxy:true}],null,true)},[_c('span',[_vm._v(_vm._s(jgmc)+"---("+_vm._s(jgh)+")")])])]}}])})],1),_c('div',{staticClass:"showNewDoginBox"},[_c('joinOrChangeStuInfo',{ref:"joinOrChangeStu",on:{"JoinOrchangeStuSuss":_vm.JoinOrchangeStuSuss}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }